import React from 'react';
import cn from 'classnames';
import { useAutoAnimate } from '@formkit/auto-animate/react';

import { Button, Display } from 'Views/Components/Button/Button';

interface IFilterContainer {
	className?: string;
	showFilters: boolean;
	onClear: () => any;
}

const FilterContainer: React.FunctionComponent<IFilterContainer> = ({
	children, className, showFilters, onClear,
}) => {
	const [animationRef] = useAutoAnimate();

	const filterContent = showFilters
		? (
			<div className="content">
				<div className="filter-list">
					{children}
				</div>
				<Button
					className="close-button"
					display={Display.Text}
					icon={{ icon: 'close', iconPos: 'icon-only' }}
					onClick={onClear}
				/>
			</div>
		) : null;

	return (
		<div
			ref={animationRef}
			className={cn('filter-container', className)}
		>
			{filterContent}
		</div>
	);
};

export default FilterContainer;
